/**
 * F44 (Wave 2D) — sub-navigation between the five finance pages
 * (/finance · /finance/settlements · /finance/refunds · /finance/exports ·
 * /finance/alert-rules). Composed of @bravemove/ui-web `Chip`s acting as a tab row.
 */
import { useI18n } from '@bravemove/i18n/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Chip } from '@bravemove/ui-web';

const TABS: ReadonlyArray<{ route: string; labelKey: string; testId: string }> = [
  { route: '/finance', labelKey: 'admin:financial.nav.dashboard', testId: 'finance-nav-dashboard' },
  {
    route: '/finance/settlements',
    labelKey: 'admin:financial.nav.settlements',
    testId: 'finance-nav-settlements',
  },
  {
    route: '/finance/refunds',
    labelKey: 'admin:financial.nav.refunds',
    testId: 'finance-nav-refunds',
  },
  {
    route: '/finance/exports',
    labelKey: 'admin:financial.nav.exports',
    testId: 'finance-nav-exports',
  },
  {
    route: '/finance/alert-rules',
    labelKey: 'admin:financial.nav.alertRules',
    testId: 'finance-nav-alert-rules',
  },
];

export function FinanceNav() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav
      className="flex flex-wrap items-center gap-2"
      aria-label={t('admin:financial.common.sections')}
    >
      {TABS.map((tab) => (
        <Chip
          key={tab.route}
          selected={pathname === tab.route}
          onClick={() => navigate(tab.route)}
          data-testid={tab.testId}
        >
          {t(tab.labelKey)}
        </Chip>
      ))}
    </nav>
  );
}
